import { RenderBasedOnHeight } from './cardContent/renderBasedOnHeight';
import { RenderBasedOnWordCount } from './cardContent/renderBasedOnWordCount';

interface ReadMoreProps {
    text: string;
    expanded?: boolean;
    renderBasedOnHeight?: boolean;
    renderBasedOnWordCount?: boolean;
}

export const BuildCardContent = (props: ReadMoreProps) => {

    if (props.renderBasedOnHeight)
        return <RenderBasedOnHeight text={props.text} expanded={props.expanded} />;
    if (props.renderBasedOnWordCount)
        return <RenderBasedOnWordCount text={props.text} expanded={props.expanded} />;
    else return '';
};
